import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../contexts/JWTAuthContext";
import "./Login.css";
import UpperPage from "../../../Components/UpperPage/UpperPage";

const Login = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();

  // Redirect to home if already logged in
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
       await login(email, password);
    } catch (err) {
      setError(t("Failed to sign in. Please check your credentials."));
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <UpperPage Title={t("Login")} />
    <div className="login-container">
      <div className="login-form-container">
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">{t("Email / Username")}</label>
            <input
              type="text"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">{t("Password")}</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? t("Logging in...") : t("Login")}
          </button>
        </form>
        <div className="register-link">
          {t("Don't have an account?")} <Link to="/register">{t("Register")}</Link>
        </div>
      </div>
    </div>
    </>
  );
};

export default Login;
